module.exports = __webpack_public_path__ + "img/05.0038a631.jpg";